// extracted by css-extract-rspack-plugin
export default {"container":"_95d22148","returnPolicyContainer":"_69d64ca2","icon":"_b0129da4"};